const IconClock = ({ className }) => {
  return (
    <svg
      className={className}
      width="18px"
      height="18px"
      viewBox="0 0 192 192"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <g transform="translate(16 16)">
        <circle
          cx="80"
          cy="80"
          r="74"
          fill="none"
          stroke="#4a4a4f"
          strokeWidth="12"
        />

        <path
          d="M80 30v50l40 32"
          fill="none"
          stroke="#4a4a4f"
          strokeWidth="12"
        />
      </g>
    </svg>
  );
};

export default IconClock;
